import React, { useRef } from 'react';
import { uploadPicUrl, changeCompanyLogoUrl } from '../../../../../Library/URLs';
import axios from 'axios';
import { v4 as uuid } from "uuid";
import { useSelector, useDispatch } from "react-redux";
import { payrollActions } from '../../../../../store';
import { CircularProgress } from "@mui/material";
import { BsCameraFill } from "react-icons/bs";
import { useParams } from 'react-router-dom';

const ChangeLogo = ({
  selectedPic,
  setSelectedPic,
  loading,
  setLoading
}) => {
  const unique_id = uuid();
  const { User } = useSelector((state) => state.payroll);
  const dispatch = useDispatch();
  const picRef = useRef();
  const { companyid } = useParams();

  const handleFileChange = (e) => {
    setSelectedPic(e.target.files[0]);
  };

  const ChangePic = async (pic_url) => {
    // setLoading(true)
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      image_url: pic_url,
    };
    await axios
      .post(changeCompanyLogoUrl, data)
      .then((res) => {
        setLoading(false);
        dispatch(payrollActions.getUser(
          {
            ...User,
            profile_image_url: pic_url
          }
        ));
      })
      .catch((err) => {
        setLoading(false);
        // console.log('Get all payroll error',err.message)
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image", selectedPic);
    setLoading(true);

    axios
      .post(uploadPicUrl, formData)
      .then((response) => {
        // Handle successful upload
        // console.log("Image uploaded:", response.data);
        setSelectedPic(response?.data)
        ChangePic(response?.data)
      })
      .catch((error) => {
        // Handle upload error
        console.error("Error uploading image:", error);
        setSelectedPic("")
      });
  };

  return (
    <div className="Theme_Wrapper">
      <div className="bottomContain">
        <div className="Row_Wrap">
          <div className="Input_Contain">
            <label htmlFor="first_name">Customize your dashboard logo</label>
            <input
              type="file"
              className="file_input"
              ref={picRef}
              onChange={(e) => {
                handleFileChange(e);
              }}
            />
            <div className="company_logo_panel">
                <img
                  // onClick={() => picRef.current.click()}
                  alt='company logo'
                  src={selectedPic}
                />
              <div className='cam_icon' onClick={() => picRef.current.click()} >
                <BsCameraFill />
              </div>
            </div>
          </div>
        </div>
        <div className="Btn_wrap">
          <button
            onClick={(e) => {
              selectedPic !== "" && handleSubmit(e);
            }}
          >
            {loading === false ? (
              "Change Logo"
            ) : (
              <CircularProgress color="inherit" size={14} />
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChangeLogo